// Classes.
import { BaseLocator } from "./../locators/base.locator";
import { StringLocatorComponent } from "./../locators/string.locator-component";
import { DisciplineLocatorComponent } from "./../locators/discipline.locator-component";
import { CategoryLocatorComponent } from "./../locators/category.locator-component";
import { CardinalityLocatorComponent } from "./../locators/cardinality.locator-component";
import { YearLocatorComponent } from "./../locators/year.locator-component";
import { DetailedLocatorComponent } from "./detailed.locator-component";
import { RankSortingLocatorComponent } from "./indoor-sorting-locator";

export class WCupRankingLocator extends BaseLocator {
  public name: StringLocatorComponent;
  public discipline: DisciplineLocatorComponent;
  public category: CategoryLocatorComponent;
  public team: CardinalityLocatorComponent;
  public year: YearLocatorComponent;
  public sortrank: RankSortingLocatorComponent;
  public detailed: DetailedLocatorComponent;
  public search: StringLocatorComponent;
  public country: StringLocatorComponent;

  constructor() {
    super("wCupRankingList");
    this.addComponentByType("discipline");
    this.addComponentByType("category");
    this.addComponentByType("team");
    this.addComponentByType("year");
    this.addComponentByType("detailed");
    this.addComponentByType("sortrank", "sortrank");
    this.addComponentByType("search");
    this.addComponentByType('country', 'country');
  }
}
